import { render } from "./add-staff-form.vue?vue&type=template&id=09a15f5c&scoped=true"
import script from "./add-staff-form.vue?vue&type=script&lang=js"
export * from "./add-staff-form.vue?vue&type=script&lang=js"

import "./add-staff-form.vue?vue&type=style&index=0&id=09a15f5c&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a15f5c"]])

export default __exports__